import type { AddressDto, UpdateAddressRequest } from "../dto/AddressDto";
import { Address, type UpdateAddressCommand } from "@domain/model/Address";
import { asAddressId } from "@domain/model/Ids";
import { asDate, iso } from "@domain/model/Time";

export const addressFromDto = (d: AddressDto): Address => ({
  id: asAddressId(d.id),
  label: d.label,
  street: d.street,
  streetNumber: d.streetNumber,
  city: d.city,
  zip: d.zip,
  country: d.country,
  lat: d.lat,
  lon: d.lon,
  version: d.version,
  createdAt: asDate(d.createdAt),
  updatedAt: asDate(d.updatedAt),
  deletedAt: d.deletedAt ? asDate(d.deletedAt) : null,
});

export const addressToDto = (a: Address): AddressDto => ({
  id: a.id,
  label: a.label,
  street: a.street,
  streetNumber: a.streetNumber,
  city: a.city,
  zip: a.zip,
  country: a.country,
  lat: a.lat,
  lon: a.lon,
  version: a.version,
  createdAt: iso(a.createdAt),
  updatedAt: iso(a.updatedAt),
  deletedAt: a.deletedAt ? iso(a.deletedAt) : null,
});

export const updateAddressCommandToDto = (
  cmd: UpdateAddressCommand,
): UpdateAddressRequest => ({
  label: cmd.label ?? null,
  street: cmd.street ?? null,
  streetNumber: cmd.streetNumber ?? null,
  city: cmd.city ?? null,
  zip: cmd.zip ?? null,
  country: cmd.country ?? null,
});
